import { useEffect, useRef, useState } from "react";

const useWordCountTime = () => {
    const [readingTime, setReadingTime] = useState();
    const findWord1 = useRef("");
    const findWord2 = useRef("");

    useEffect(() => {
        let Read_Per_Mins = 250;
        let wordCountFirst = findWord1.current.innerText.trim().split(" ").length;
        let wordCountSecond = findWord2.current.innerText.trim().split(" ").length;
        let wordCount = wordCountFirst + wordCountSecond;
        let time = Math.ceil(wordCount / Read_Per_Mins);
        if (time < 10) {
            time = "0" + time;
        }
        setReadingTime(time);
    }, [])

    return [readingTime, findWord1, findWord2];

}

export default useWordCountTime;